<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18.0904 12.5274C18.1649 12.6233 18.2116 12.739 18.2251 12.861C18.2386 12.9831 18.2183 13.1066 18.1667 13.2173C18.115 13.328 18.034 13.4215 17.933 13.4869C17.832 13.5523 17.7151 13.587 17.5959 13.587H4.08473V16.8478C4.08473 17.5 3.24028 17.5 3.24028 17.5C3.07231 17.5 2.70011 17.4313 2.58133 17.309C2.46256 17.1867 2.39583 17.0208 2.39583 16.8478V3.15217C2.39584 2.97921 2.46257 2.81333 2.58134 2.69103C2.70011 2.56872 2.8612 2.50001 3.02917 2.5H17.5959C17.7151 2.5 17.832 2.5347 17.933 2.6001C18.034 2.6655 18.115 2.75893 18.1667 2.86965C18.2183 2.98036 18.2386 3.10386 18.2251 3.22591C18.2116 3.34797 18.1649 3.46361 18.0904 3.55954L14.6069 8.04348L18.0904 12.5274Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
